import { directionResult } from '@utils/directionResult';
import { Icon } from '../ListProducts.styles';

interface ArrowProps {
  isSorted: boolean;
  direction: 'ASC' | 'DESC' | undefined;
}

export function ArrowSort({ isSorted, direction }: ArrowProps) {
  return (
    <>
      {isSorted ? (
        <div>
          <Icon data-direction={directionResult(direction)} />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
